// src/pages/About.jsx
import React, { useState, useEffect, useRef } from 'react';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';
import HeroSection from '../components/about/HeroSection';
import PhilosophySection from '../components/about/PhilosophySection';
import GallerySlider from '../components/about/GallerySlider';
import OurTeamSection from '../components/about/OurTeamSection';

import pic1 from '../assets/img14.jpg';
import pic2 from '../assets/img21.jpg';
import pic3 from '../assets/img33.jpg';
import pic4 from '../assets/img37.jpg';

const galleryImages = [pic1, pic2, pic3, pic4];

export default function About() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (isPaused) return;
    intervalRef.current = setInterval(() => {
      setCurrentIndex((i) => (i + 1) % galleryImages.length);
    }, 4000);
    return () => clearInterval(intervalRef.current);
  }, [isPaused]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <PhilosophySection />
      <OurTeamSection />
      <GallerySlider 
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        isPaused={isPaused}
        setIsPaused={setIsPaused}
        images={galleryImages}
      />
      <Footer />
    </div>
  );
}